export default class Accordion {

    constructor() {
        this.settings = {
            el: document.getElementsByClassName('js-accordion-btn')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        let i;

        for (i = 0; i < this.settings.el.length; i++) {

            this.settings.el[i].addEventListener('click', (e) => {
                const panel = e.currentTarget.nextElementSibling;

                e.currentTarget.classList.toggle('active');
                panel.classList.toggle('open');

                if (panel.style.maxHeight) panel.style.maxHeight = null;
                else panel.style.maxHeight = panel.scrollHeight + 'px';
            });

        }

    }

};

new Accordion();